import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SiteWorkOrdersService } from 'app/_services/site-work-orders.service';
import { SiteFormsService } from 'app/_services/site-forms.service';
import Swal from 'sweetalert2';
import { Pagination } from 'app/_models/pagination.model';

@Component({
  selector: 'edit-site-form-modal',
  templateUrl: './edit-site-form-modal.component.html',
})
export class EditSiteFormModalComponent implements OnInit {
  @Input() workOrder: any;
  @Input() isCheckOnModal: boolean;

  public form: FormGroup;
  public siteFormsOptions: any[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private workOrderService: SiteWorkOrdersService,
    private siteFormsService: SiteFormsService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      siteFormCheckOn: new FormControl(),
      siteFormCheckOff: new FormControl(),
    });
    this.getSiteFormsForEdit();
  }

  private getSiteFormsForEdit() {
    const pagination: Pagination = {
      size: 10000,
      page: 0,
      totalRecords: 0,
    };

    this.siteFormsService.getAllBySite(this.workOrder.asset.site.id, pagination, ["siteForm.name"]).subscribe((siteForms: any) => {
      this.siteFormsOptions.push({ label: "No Site Form Required", value: null});
      siteForms.body.forEach((element) => {
        const item = {
          label: element.name,
          value: element.id,
        };
        if(element.id === this.workOrder.checkOnSiteFormId && this.isCheckOnModal){
          this.form.reset();
          this.form.patchValue({
            siteFormCheckOn: item,
          });
        }
        if(element.id === this.workOrder.checkOffSiteFormId && !this.isCheckOnModal){
          this.form.reset();
          this.form.patchValue({
            siteFormCheckOff: item,
          });
        }
        this.siteFormsOptions.push(item);
      });
    });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }


  public onSubmit() {
    const values = this.form.value;

    const body = {
      checkOnSiteFormId: this.isCheckOnModal ? values.siteFormCheckOn.value : this.workOrder.checkOnSiteFormId,
      checkOffSiteFormId: !this.isCheckOnModal ? values.siteFormCheckOff.value  : this.workOrder.checkOffSiteFormId,
      //include these fields for required for workOrder put:
      minimumPartySize : this.workOrder.minimumPartySize,
      id: this.workOrder.id,
      released: this.workOrder.released,
      approvalStatus: this.workOrder.approvalStatus,
      description: this.workOrder.description,
      scheduledStartTime: this.workOrder.scheduledStartTime,
      scheduledEndTime: this.workOrder.scheduledEndTime,
      exemptFromAssetScheduling: this.workOrder.exemptFromAssetScheduling,
    };

    this.workOrderService.updateWorkOrder(body).subscribe(() => {
      Swal.fire('Updated!', 'Work Order has been updated.', 'success');
      this.activeModal.close('refresh');
    });
  }
}
